module.exports = __webpack_public_path__ + "static/ohio-crest-tee-41cc7e9352695ce26fa04c947474acc5.webp";